import {inject, injectable} from "inversify";
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import eventsObservable from "../../events/EventsObservable";
import {STATES} from "../../states/states";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import Wallet, {WALLET_EVENTS} from "../../wallet/Wallet";
import {removeUndefined} from "../../helpers";
import IGame from "../../game/slot/GameSlots";
import BaseHwButtonsStates from "./BaseHwButtonsStates";
import {EVENTS} from "../../events/baseEvents";
import { parseURL } from '../../connect/Connect'

const LAMPS = {
    "ALL": "all",
    "START": "0",
    "AUTO": "1",
    "BETUP": "2",
    "BETDONW": "3",
    "MOREGAMES": "4",
    "MAXBET": "5",
    "GAMBLE": "6",
    "CASHOUT": "7",
    "INFO": "8",
};

const URL = "http://localhost:8888/v1/gpio/outputs/outs";
const GAME_INIT_URL = "http://localhost:8888/v1/init/{game_id}";
const MENU_INIT_URL = "http://localhost:8888/v1/init/menu";
const RGB_URL = "http://localhost:5000/led/rgb";
const METHOD = "POST";

const ticks = 4;

@injectable()
export default class ButtonsYouHoo extends BaseHwButtonsStates {

    private config: SystemConfig;
    private _wallet: any;

    private lamps = [];

    private jsonLampsStr: string = null;
    private game: IGame;

    constructor(
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame
    ) {
        super();

        this.config = config;
        this._wallet = wallet;
        this.game = game;

        eventsObservable.subscribe(WALLET_EVENTS.WALLET_ON_SET_BET, this);
        eventsObservable.subscribe(EVENTS.INIT_SUCCESS, this);
        // eventsObservable.subscribe(AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT, this);
    }

    /**
     * @override
     */
    notify(eventName, data) {

        switch (eventName) {
            case WALLET_EVENTS.WALLET_ON_SET_BET:
                this.setState(this.stateName, this.data, true);
                break;

            case EVENTS.INIT_SUCCESS:
                return this.init();

            // case AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT:
            //     this.autostartLamps(data);
            //     break;
        }

    }

    getFetchSettings(body: any) {
        let init = {
            mode: undefined,
            // mode: "no-cors",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            },
            body: body,
            method: "POST"
        };

        if(this.config.get(CONFIG_PARAMS.NOCORS)) {
            init.mode = "no-cors";
        }

        init = removeUndefined(init);
        return init;
    }

    init() {
        // try {
        //     // @ts-ignore
        //     fetch(parseURL(GAME_INIT_URL, {game_id: this.config.get(CONFIG_PARAMS.GAME_ID)}), this.getFetchSettings());
        // } catch (e) {
        //     console.log(e);
        // }
        try {
            // @ts-ignore
            fetch(RGB_URL, this.getFetchSettings(this.getRGB()));
        } catch (e) {
            console.log(e);
        }
    }

    getRGB(): string {
    	switch (this.config.get(CONFIG_PARAMS.GAME_ID)) {
			case "secret_rose": case "secret_rose_dice":
				return JSON.stringify({red: "245", green: "152", blue: "027"})
			case "joker_boom": case "joker_boom_plus":
				return JSON.stringify({red: "040", green: "003", blue: "000"})
			case "alchemy":
				return JSON.stringify({red: "007", green: "020", blue: "016"})
			case "multi_diamonds_81":
				return JSON.stringify({red: "040", green: "012", blue: "002"})
			case "super_joker_40":
				return JSON.stringify({red: "050", green: "001", blue: "000"})
			case "monster_slots":
				return JSON.stringify({red: "035", green: "020", blue: "010"})
			case "ultimate_crystals":
				return JSON.stringify({red: "035", green: "020", blue: "010"})
			case "multi_vegas_81":
			case "retro_wheels": case "retro_wheels_dice":
			case "tutti_frutti": case "tutti_frutti_dice":
				return JSON.stringify({red: "045", green: "000", blue: "000"})
			case "bad_wolf": case "bad_wolf_dice":
				return JSON.stringify({red: "000", green: "005", blue: "026"})
    	}
    }

    /**
     * @override
     */
    async turnOff() {
        try {
            // @ts-ignore
            await fetch(MENU_INIT_URL, this.getFetchSettings());
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * @override
     */
    async setState(stateName: string, data?, reset = false): Promise<any> {

        await super.setState(stateName, data, reset);

        // console.log(stateName, this.game.round.isRunning(), !this.game.autostart?.isAutostart());

        if (stateName != STATES.IDLE && !this.game.autostart?.isAutostart()) {
            this.lamps = this.lamps.filter((lamp) => lamp.id != LAMPS.AUTO);
        }

        this.setLamps(this.lamps);
    }

    private async setLamps(lamps) {

        if(!lamps.length) return;

        let lampsStr = JSON.stringify(lamps);

        if(this.jsonLampsStr == lampsStr) return;
        this.jsonLampsStr = lampsStr;
        this.lamps = lamps;

        return this._fetch(JSON.stringify({ lamps: lamps }));
    }

    _createLamp(id, state, onTicks = null, offTicks = null) {

        let lamp = {
            id: id,
            state: state,
            onTicks: undefined,
            offTicks:undefined
        };

        if(onTicks != null) {
            lamp.onTicks = onTicks;
        }

        if(offTicks != null) {
            lamp.offTicks = offTicks;
        }

        lamp = removeUndefined(lamp);

        return lamp;
    }

    /**
     * @override
     */
    async statePreinfo() {

        let lamps = [];
        lamps.push(this._createLamp(LAMPS.ALL, false));
        lamps.push(this._createLamp(LAMPS.MOREGAMES, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.START, true, ticks, ticks));

        this.lamps = lamps;
    }

    /**
     * @override
     */
    async stateIdle() {

        let buttons = [];

        this._betButtons(buttons);

        let lamps = [];
        lamps.push(this._createLamp(LAMPS.ALL, false));
        lamps.push(this._createLamp(LAMPS.MOREGAMES, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.INFO, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.START, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.AUTO, true, ticks, ticks))
        lamps.push(this._createLamp(LAMPS.MAXBET, true, ticks, ticks));
        lamps = lamps.concat(buttons);

        this.lamps = lamps;
        // this.setLamps(lamps);
    }

    /**
     * @override
     */
    async stateFsIdle() {

        let lamps = [];
        lamps.push(this._createLamp(LAMPS.ALL, false));
        lamps.push(this._createLamp(LAMPS.MOREGAMES, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.START, true, ticks, ticks));

        this.lamps = lamps;
    }

    private _betButtons(lamps) {

        if(this._wallet.nextCreditBet() != null) {
            lamps.push(this._createLamp(LAMPS.BETUP, true, ticks, ticks));
        } else {
            lamps.push(this._createLamp(LAMPS.BETUP, false));
        }

        if(this._wallet.prevCreditBet() != null) {
            lamps.push(this._createLamp(LAMPS.BETDONW, true, ticks, ticks));
        } else {
            lamps.push(this._createLamp(LAMPS.BETDONW, false));
        }
    }

    /**
     * @override
     */
    async stateSpin() {

        let lamps = [];
        lamps.push(this._createLamp(LAMPS.ALL, false));
        lamps.push(this._createLamp(LAMPS.MOREGAMES, true, ticks, ticks));
        lamps.push(this._createLamp(LAMPS.START, true, ticks, ticks));

        if(this.game.autostart?.isAutostart()) {
            lamps.push(this._createLamp(LAMPS.AUTO, true, ticks, ticks));
        }

        this.lamps = lamps;
    }

    /**
     * @override
     */
    async stateBonus() {
        this.stateBonusWin();
    }

    /**
     * @override
     */
    async stateBonusWin() {

        let lamps = [];
        lamps.push(this._createLamp(LAMPS.ALL, false));
        lamps.push(this._createLamp(LAMPS.MOREGAMES, true, ticks, ticks));

        if(this.game.autostart?.isAutostart()) {
            lamps.push(this._createLamp(LAMPS.AUTO, true, ticks, ticks));
        }

        this.lamps = lamps;
    }

    private async _fetch(data) {

        console.log(data);

        // @ts-ignore
        return fetch(URL, this.getFetchSettings(data));
    }
}
